import React, {Component} from "react";
import { HeaderWithControl } from "../../../common/titlewithbutton-layout/header-with-control";
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { inventoryCircuitInvoiceActions } from "../../../../store/external/inventory/invoice/invoice.reducer";
import { MODAL_CUSTOM_MESSAGE, ROUTE_LINK_LOCATION } from '../../../../constants/external-constants';


class InvoiceCircuit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enableSearchBox: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
        };
   
    }
    componentDidMount() {
        const { getInventoryCircuitInvoice, getInventoryCircuitDispute, circuitId, financeAccountId } = this.props;
        getInventoryCircuitInvoice(circuitId, financeAccountId);
        getInventoryCircuitDispute(circuitId);
    }
    componentWillUnmount() {
        this.props.setDefaultInvoiceTab();
    }
    getInventoryCircuitInvoice = (pageIndex) => {
        const { getInventoryCircuitInvoice, circuitId, financeAccountId } = this.props;
        getInventoryCircuitInvoice(circuitId, financeAccountId, pageIndex);
    }

    onColumnSearchInvoice = () => {
        this.setState({ displaySearch: !this.state.displaySearch })
        const { getInventoryCircuitInvoice, circuitId, financeAccountId } = this.props;
        getInventoryCircuitInvoice(circuitId, financeAccountId, 0);
    }
    onColumnSearchDispute = () => {
        this.setState({ displaySearch: !this.state.displaySearch })
        const { getInventoryCircuitDispute, circuitId } = this.props;
        getInventoryCircuitDispute(circuitId, 0);
    }
    onColumnSortInvoice = (columnClicked, isSortedAsc) => {
        const { sortInventoryCircuitInvoice, circuitId, financeAccountId } = this.props;
        sortInventoryCircuitInvoice(columnClicked, isSortedAsc, circuitId, financeAccountId);
    }
    onColumnSortDispute = (columnClicked, isSortedAsc) => {
        const { sortInventoryCircuitDispute, circuitId } = this.props;
        sortInventoryCircuitDispute(columnClicked, isSortedAsc, circuitId);
    }
    displaySearchBox(value){
        this.setState(prevState => ({ 
            enableSearchBox: prevState.enableSearchBox === value ? null : value 
        }));
    }
    onClickExtractInvoice = () => {
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractCircuitInvoice(this.props.circuitId, this.props.financeAccountId);
        }
    }
    onClickExtractDispute = () => {
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractCircuitDispute(this.props.circuitId);
        }
    }
    rowDisputeAction = (item, hasLink) => {
        if (hasLink && item.DisputeId) {
            window.open(`${ROUTE_LINK_LOCATION.invoiceDisputeDetailsLink}/${item.DisputeId}`, "_blank")

        } else {
            this.setState({ showModal: true, selectedItem: item })
        }
    }
    rowInvoiceAction = (item, hasLink) => {
        if (hasLink && item.InvoiceId) {
            window.open(`${ROUTE_LINK_LOCATION.invoiceRouteLink}/${item.InvoiceId}`, "_blank")

        } else {
            this.setState({ showModal: true, selectedItem: item })
        }
    }
    render(){
        const { getInventoryCircuitInvoice, inventoryCircuitInvoice, setInventoryCircuitInvoiceColSearchStr, getInventoryCircuitDispute, inventoryCircuitDispute, setInventoryCircuitDisputeColSearchStr, sortInventoryCircuitInvoice } = this.props;     
        return(
           <div className="details-container">
            <HeaderWithControl
                title="invoices" 
                displaySearchBox={this.displaySearchBox.bind(this)}
                extractAction={this.onClickExtractInvoice}
                isReadOnly={this.props.isReadOnly}
                isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                isReadAndWrite={this.props.isReadAndWrite}
            >
                    <TablePagination
                    key="table-pagination-key"
                    columns={inventoryCircuitInvoice.inventoryCircuitInvoiceItems.Headers}
                    pageList={inventoryCircuitInvoice.inventoryCircuitInvoiceItems.Data.Items}
                    pages={inventoryCircuitInvoice.inventoryCircuitInvoiceItems.Pagination}  
                    rowClickAction={(item, hasLink) => { this.rowInvoiceAction(item, hasLink) }}
                    paginationAction={this.getInventoryCircuitInvoice}
                    onColumnClick={this.onColumnSortInvoice }
                    onColumnSearch={() => { this.onColumnSearchInvoice() }}
                    onColumnSearchChange={setInventoryCircuitInvoiceColSearchStr}
                    isColSearchShow={this.state.enableSearchBox === "invoices"}
                    resizePage={() => { } }
                    totalPage={inventoryCircuitInvoice.inventoryCircuitInvoiceItems.Pagination.TotalEntries}
                    isNotSortable={false}
                    isLoading={false}  
                    haveLink={true}
                    hidePageSizeSelection={true}
                />
            </HeaderWithControl>
                <div className="horizontal-separator seprator-margin-bottom-top"></div>
            <HeaderWithControl 
                title="disputes"  
                displaySearchBox={this.displaySearchBox.bind(this)}
                extractAction={this.onClickExtractDispute}
                isReadOnly={this.props.isReadOnly}
                isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                isReadAndWrite={this.props.isReadAndWrite}
            >
                <TablePagination  
                    key="table-pagination-key"
                    columns={inventoryCircuitInvoice.inventoryCircuitDisputeItems.Headers}
                    pageList={inventoryCircuitInvoice.inventoryCircuitDisputeItems.Data.Items}
                    pages={inventoryCircuitInvoice.inventoryCircuitDisputeItems.Pagination}  
                    rowClickAction={(item, hasLink) => { this.rowDisputeAction(item, hasLink) }}
                    paginationAction={(value) => { getInventoryCircuitDispute(this.props.circuitId, value)}}
                    onColumnClick={this.onColumnSortDispute }
                    onColumnSearch={() => { this.onColumnSearchDispute() }}
                    onColumnSearchChange={setInventoryCircuitDisputeColSearchStr}
                    isColSearchShow={this.state.enableSearchBox === "disputes"}
                    resizePage={() => { } }
                    totalPage={inventoryCircuitInvoice.inventoryCircuitDisputeItems.Pagination.TotalEntries}
                    isNotSortable={false}
                    isLoading={false}    
                    haveLink={true}
                    noAvailableData={true}
                    hidePageSizeSelection={true}
                />
            </HeaderWithControl>
           </div>
        )
    }
}

export default connect(
    state => {
        const { inventoryCircuitInvoice } = state;

        return {
            inventoryCircuitInvoice
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, inventoryCircuitInvoiceActions),
        dispatch
    )
)(InvoiceCircuit);